<template lang="pug">
    section#banner
        div.wrapper
            div.texto
                h3
                    | A política de descontos mudou
                    br
                    | e a partir de agora
                    br
                    | com
                    span  descontos especiais
                    |  para
                    strong Graduação e Pós.
            div.img
                img(:src="require('@images/egressos/egressos-modelo3.png')", alt="")
</template>

<script>
export default {
    name: "section-banner"
}
</script>

<style lang="stylus" scoped src="./Banner.styl"></style>
